export enum _ComTypeGeneric {
  IRIDIUM = 'Iridium',
  GLOBALSTAR = 'Globalstar',
  GSM = 'GSM',
  IoT = 'IoT',
}
